import $ from 'jquery';

function init() {
  let $focusedElBeforeOpen;

  // Toggle helpers
  function openTarget(target) {
    $focusedElBeforeOpen = $(':focus');

    target.addClass('active');

    const focusableEl = target.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]').first();

    focusableEl.focus();

    target.keydown((event) => {
      if (event.which === 27) {
        closeTarget(target);
      }
    });
  }
  function closeTarget(el) {
    el.removeClass('active');
    if ($focusedElBeforeOpen) {
      $focusedElBeforeOpen.focus();
    }
  }

  function toggleTarget() {
    console.log("Toggle")
    const target = $(this).data('target-trigger');
    const $genTarget = $(`[data-target]`); 
    const $targetEl = $(`[data-target="${target}"]`);
    if ($targetEl.hasClass('active')) {
      closeTarget($targetEl);
    } else {
      closeTarget($genTarget);
      openTarget($targetEl);
    }
  }
  
  function toggleTargetStrict(event) {
    console.log("Toggle Strict")
    const target = $(this).data('target-trigger-strict');
    const $genTarget = $(`[data-target]`); 
    const $targetEl = $(`[data-target="${target}"]`);
    if ($(this)[0] === event.target) {
      if ($targetEl.hasClass('active')) {
        closeTarget($targetEl);
      } else {
        closeTarget($genTarget);
        openTarget($targetEl);
      }
    }
  }

  $('[data-target-trigger]').on('click', toggleTarget);

  $('[data-target-trigger-strict]').on('click', toggleTargetStrict);

  // Open helper
  function toggleOpen() {
    const target = $(this).data('open-trigger');

    $(`[data-open="${target}"]`).addClass('open');
  }

  $('[data-open-trigger]').on('click', toggleOpen);

  // Close helper
  function toggleClose() {
    const target = $(this).data('close-trigger');
    $(`[data-close="${target}"]`).removeClass('active');
  }

  $('[data-close-trigger]').on('click', toggleClose);
}

$(function () {
  init();
})